export default __webpack_public_path__ + "static/media/smiley-02.e44f8687.png";